const EncryptionKey = () => {
  return process.env.REACT_APP_ENCRYPT_KEY || "";
};

export default EncryptionKey;
